/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Zalo_InvalidInputs */

const vi_error_shop_zalo_invalid = /** @type {(inputs: Error_Shop_Zalo_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số điện thoại Zalo hoặc link bắt đầu bằng http:// hay https://.`)
};

/**

* @param {Error_Shop_Zalo_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_zalo_invalid = /** @type {((inputs?: Error_Shop_Zalo_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Zalo_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_zalo_invalid(inputs)
});